module.exports = __webpack_public_path__ + "static/eis_charlie_logo-9e51b1867864ae1bb65c58ed8aad5eff.png";